import { WORLDWIDE_COUNTRY_ID } from "app/services/countryServiceConst";

import type { BuildKeywordListId } from "./types";

export const buildKeywordGroupKeywordListId: BuildKeywordListId<"KeywordGroup"> = (id) => `KeywordGroup;${id}`;

export const buildSearchTermKeywordListId: BuildKeywordListId<"SearchTerm"> = (seed, country) =>
    `SearchTerm;${seed};${country}`;

export const buildAiTopicKeywordListId: BuildKeywordListId<"AiTopic"> = (seed) =>
    `AiTopic;${seed};${WORLDWIDE_COUNTRY_ID}`;
